module.exports = __webpack_public_path__ + "static/media/twi.f210d334.svg";